import React, { useMemo } from 'react';
// import { useCallback } from 'react';
// import { Accessibility } from 'lucide-react';
// import { translate } from '@/services/TranslationService';
import NOVOLoader from '@/shared/components/NOVOLoader';
import FiltersComponent from '../FiltersComponent';
// import { ACCESSIBLE_JOURNEYS_SECTION_ID } from '../FiltersComponent';
import MapBoxContainer from '../MyCityMapContainer';

const MyCityDesktopLayout = ({
  mapProps,
  filtersProps,
  markersLoaded,
  loaderStyles,
}) => {
  const accessibleJourneysGroup = useMemo(
    () =>
      filtersProps.geozoneFilterGroups?.find(
        (group) => group.name === 'accessible_journeys'
      ),
    [filtersProps.geozoneFilterGroups]
  );

  /* FAB temporarily disabled.
  const accessibleJourneysLabel = translate('MYCITY.AccessibleJourneys');

  const scrollToAccessibleJourneys = useCallback(() => {
    const section = document.getElementById(ACCESSIBLE_JOURNEYS_SECTION_ID);
    if (!section) return;

    section.focus({ preventScroll: true });
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);
  */

  return (
    <div className="flex max-h-[calc(100vh-5rem)] p-0 sm:h-fit sm:p-[2.5rem] sm:pb-0 sm:pt-[2rem]">
      <div className="flex w-full flex-col gap-[1.5rem] overflow-auto rounded-0 bg-white p-[1.5rem] sm:rounded-[1rem] sm:p-[2rem]">
        <div
          className={
            markersLoaded && accessibleJourneysGroup ? 'mb-[8px]' : undefined
          }
          style={{
            minHeight: 450,
            position: 'relative',
            background: '#eee',
          }}
        >
          {markersLoaded ? (
            <MapBoxContainer {...mapProps} />
          ) : (
            <NOVOLoader style={loaderStyles} />
          )}
          {/* {markersLoaded && accessibleJourneysGroup && (
            <button
              type="button"
              onClick={scrollToAccessibleJourneys}
              className="absolute bottom-[-21px] left-1/2 z-[6] flex h-[42px] w-[42px] -translate-x-1/2 items-center justify-center rounded-full border border-strongCyan bg-strongCyan text-white shadow-md transition-colors hover:bg-strongCyan/90 focus:outline-none focus:ring-2 focus:ring-strongCyan focus:ring-offset-2"
              aria-label={accessibleJourneysLabel}
              title={accessibleJourneysLabel}
            >
              <Accessibility aria-hidden="true" className="h-[24px] w-[24px]" />
            </button>
          )} */}
        </div>
        <FiltersComponent isMobile={false} {...filtersProps} />
      </div>
    </div>
  );
};

export default MyCityDesktopLayout;
